import { useState } from 'react';
import Select from 'react-select';

import Table from '../Table/Table';
import camposTabla from '../Table/fixtures';

import { compensarLoader, serviceGet } from '../helpers/utils';

const colourStyles = {
  control: (styles, { isDisabled }) => ({
    ...styles,
    height: 33,
    minHeight: 33,
    backgroundColor: isDisabled ? '#eee' : 'white',
    borderColor: isDisabled ? '#ccc' : styles.borderColor,
    ':focus': {
      ...styles[':focus'],
      backgroundColor: '#f8f4de',
      borderColor: '#ff6600',
    },
    ':hover': {
      ...styles[':hover'],
      backgroundColor: '#f8f4de',
      borderColor: '#ff6600',
    },
    ':active': {
      ...styles[':active'],
      backgroundColor: '#f8f4de',
      borderColor: '#ff6600',
    },
    ':disabled': {
      ...styles[':disabled'],
      backgroundColor: '#eee',
    },
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const mainColor = '#ff6600';
    const soft_orange = '#ff944d';
    return {
      ...styles,
      backgroundColor: isSelected ? soft_orange : isFocused ? mainColor : null,
      color: isSelected || isFocused ? 'white' : 'black',
      ':active': {
        ...styles[':active'],
        backgroundColor: mainColor,
      },
    };
  },

  input: (styles) => ({ ...styles }),
  placeholder: (styles) => ({ ...styles }),
  singleValue: (styles, { data }) => ({ ...styles }),
};

function filtrarYTransformar(array, filtro) {
  return array
    .map((item) => {
      const tieneValorX = item.Valores.some((val) => val.NombreInternoCampo === filtro && val.Valor === 'X');
      if (tieneValorX) {
        return item.Valores.reduce((obj, val) => {
          obj[val.NombreInternoCampo] = val.Valor;
          return obj;
        }, {});
      }

      return null;
    })
    .filter((item) => item !== null);
}

function Filters({ onDepartamentoSelect, departamentosList, ciudadesList, onFilterSelect, filterData, tipoFiltro }) {
  console.log('filterData', filterData);
  const [tableData, setTableData] = useState([]);

  const getData = () => {
    compensarLoader(true);
    serviceGet(
      {
        Accion: 'GET',
        Lista: 'Red_Consolidado_2335',
        UrlSitio: window.location.origin + '/salud/',
        Vista: [
          'NIT',
          'Razon_social_proveedor',
          'Sede_atencion',
          'Direccion_sede_atencion',
          'Depto_sede_atencion',
          'Mpio_sede_atencion',
          'Canal',
          'REPS_Apoyo_diagnostico',
          'REPS_Atencion_inmediata',
          'REPS_Consulta_externa',
          'REPS_Internacion',
          'REPS_Quirurgicos',
          'REPS_Transporte_asistencial',
          'OT_Entrega',
          'CLAS_Promocion_mto',
          'CLAS_Materno_perinatal',
          'CLAS_Condiciones_cardiometabolic',
          'CLAS_Enfermedad_x0020__renal',
          'CLAS_Salud_mental_sustancias_psi',
          'CLAS_EPOC_asma',
          'CLAS_Cancer_adultos',
          'CLAS_Cancer_infantil',
          'CLAS_Virus_inmunodeficiencia',
          'CLAS_Artritis_reumatoide',
          'CLAS_Enfermedades_huerfanas',
          'CLAS_Enfermedades_vectores',
        ],
        Campos: {
          Query: [
            {
              NombreInternoCampo: 'Depto_sede_atencion',
              Valor: filterData.Departamento.value.toUpperCase(),
              Tipo: 'Text',
              Condicion: 'Eq',
            },
            {
              NombreInternoCampo: 'Mpio_sede_atencion',
              Valor: filterData.Ciudad?.value?.toUpperCase() || '',
              Tipo: 'Text',
              Condicion: 'Eq',
            },
          ],
        },
      },
      'UtilidadSharepointGet',
      'ServicioTransar.svc',
    ).then((data) => {
      if (data.ResponseCode === 200 && data.ResponseDetail === 'Ok') {
        setTableData(filtrarYTransformar(data.Result.Resultado, tipoFiltro));
        compensarLoader(false);
      }
    });
  };

  return (
    <>
      <div className="filters">
        <div className="row">
          <div className="col-sm-4">
            <label htmlFor="Departamento" id="label-departamento">
              Departamento
            </label>
            <Select
              id="Departamento"
              name="Departamento"
              placeholder="Departamento"
              value={filterData.Departamento}
              onChange={onDepartamentoSelect}
              options={departamentosList}
              styles={colourStyles}
              isDisabled={false}
              required="required"
            />
          </div>
          <div className="col-sm-4">
            <label htmlFor="Ciudad" id="label-ciudad">
              Ciudad
            </label>
            <Select
              id="Ciudad"
              name="Ciudad"
              placeholder="Ciudad"
              value={filterData.Ciudad}
              onChange={(e) => onFilterSelect(e, 'Ciudad')}
              options={ciudadesList}
              styles={colourStyles}
              isDisabled={ciudadesList.length === 0}
              required="required"
            />
          </div>
          <div className="col-sm-4 filters-btn">
            <button
              type="button"
              className="btn btn-default"
              onClick={getData}
              disabled={!filterData?.Departamento?.value || !filterData?.Ciudad?.value}
            >
              {parseText('rutasServicios.btns.buscar')}
            </button>
          </div>
        </div>
        <div className="row mandatory-text">Los campos marcados con asterisco son obligatorios.</div>
      </div>
      <Table identificator={`table_a`} data={tableData} fields={camposTabla} isEmpty={tableData.length === 0} />
    </>
  );
}

export default Filters;
